import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useSetAtom } from "jotai";
import {
	spotOrderingSelectionModelAtom,
	unsavedChangesAtom,
} from "../../../../components/Atoms/atoms";
import { createEmptyRowSelectionModel } from "./selectionModel";

export default function ConfirmCancelDialog(props) {
	const setSelectionModel = useSetAtom(spotOrderingSelectionModelAtom);
	const setUnsavedChanges = useSetAtom(unsavedChangesAtom);

	const handleClose = () => {
		props.setOpen(false);
	};

	const handleConfirmClearSelection = () => {
		props.setConfirmSubmitAllSelected(false);
		// Reset rows that were only marked for temporary batch submission.
		const updatedRows = props.rows.map((row) => {
			if (row.evaluate === "Pending") {
				return { ...row, evaluate: "" };
			}
			return row;
		});
		props.setRows(updatedRows);
		setSelectionModel(createEmptyRowSelectionModel());
		setUnsavedChanges(false);
		props.setBatchUpdated(false);
		props.setOpen(false);
	};
	return (
		<div>
			<Dialog open={props.open} onClose={handleClose} maxWidth="xl">
				<DialogTitle textAlign={"center"}>Confirm Cancellation:</DialogTitle>

				<DialogContent sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<DialogContentText sx={{ maxWidth: "600px", color: "black" }}>
						You have made changes to multiple courses without saving/submitting. If you proceed to
						cancel, all changes will be lost.
					</DialogContentText>
					<DialogContentText sx={{ maxWidth: "600px", color: "black" }}>
						If you are sure you want to proceed, click on "Confirm Cancellation".
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button onClick={handleConfirmClearSelection} autoFocus color="error">
						Confirm Cancellation
					</Button>
					<Button onClick={handleClose} variant="contained">
						Cancel
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
